import {Component, OnInit} from '@angular/core';
import {DialogComponent, DialogService} from 'ng2-bootstrap-modal';
import 'rxjs/add/operator/switchMap';
import {UtilsService} from '../services/utils.service';

export interface ConfirmDialogModel {
  title: string;
  data: any;
  showCancelButton: boolean;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent extends DialogComponent<ConfirmDialogModel, boolean> implements OnInit {
  title: string;
  data: any;

  constructor(dialogService: DialogService, private utilsService: UtilsService) {
    super(dialogService);
  }

  ngOnInit() {
      // console.log('Confirm');
      // console.log(this.data);
    document.getElementsByTagName('body')[0].classList.add('modal-open');
    if (this.data.message) {
        this.data.message = this.utilsService.decodeHtml(this.data.message);
    } else {
        this.data.message = 'There was an unexpected error.'
            + ' Please try again or contact <a href="mailto:support@openlm.com">support@openlm.com</a> if error persists.';
    }
  }

  ok() {
    this.result = true;
    this.close();
  }

  cancel() {
      this.result = false;
      this.close();
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/confirm/confirm-dialog.component.ts